import { replaceCommentsTemplateExpressions, replaceNewLinesTemplateExpressions } from '@/app/lib/utils/jsx-preview-utils';
import type { ReactElement, ReactNode } from 'react';
import reactElementToJSXString from 'react-element-to-jsx-string';
// eslint-disable-next-line import/named
import { html as beautify_html, js as beautify_js } from 'js-beautify';

export const firstLetterCase = (value: string) => value.charAt(0).toUpperCase() + value.slice(1);

export const kebabCase = (value: string) =>
  value
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/\s+/g, '-')
    .toLowerCase();

export const normalizeHTML = (html: string) =>
  html
    .replace(/(fetchPriority|fetchpriority)=(['"])(high|low)(['"])/gi, '')
    .replace(/loading=(['"])(eager|lazy)(['"])/g, '')
    .replace('&nbsp;', ' ')
    .replace('&apos;', "'")
    .replace('&quot;', '"');

export const formatHTML = (html: string) => {
  const beautified = beautify_html(normalizeHTML(html), {
    indent_size: 2,
    wrap_line_length: 250,
    inline_custom_elements: false,
    inline: [],
  });

  return replaceCommentsTemplateExpressions(replaceNewLinesTemplateExpressions(beautified, 'html'), 'html'); // needs to be done after beautify
};

export const formatJS = (js: string) => {
  return beautify_js(js.replace(/<\/?script>/g, ''), {
    indent_size: 2,
    wrap_line_length: 250,
  });
};

export const elementToJsxString = (
  element: ReactElement,
  {
    displayName,
    filterProps = [],
    maxInlineAttributesLineLength = 120,
  }: { displayName?: string | ((element: ReactNode) => string); filterProps?: string[]; maxInlineAttributesLineLength?: number } = {}
) =>
  reactElementToJSXString(element, {
    showDefaultProps: true,
    maxInlineAttributesLineLength,
    sortProps: false,
    displayName: displayName
      ? element => {
          if (typeof displayName === 'string') {
            return displayName;
          }

          return displayName(element);
        }
      : undefined,
    filterProps: (value: string, key) => {
      const imgFetchPriorityCond = key === 'fetchPriority' && ['high', 'low'].includes(value);
      const imgLoadingCond = key === 'loading' && ['eager', 'lazy'].includes(value);

      return !(imgFetchPriorityCond || imgLoadingCond || key.endsWith('$$') || filterProps.includes(key));
    },
  });
